<template>
	<div id="footers">
		<div class="inner">
			<div class="tab">
				<div @click.stop="$router.push('/about')">{{i18n('27')}}</div>
				<div @click.stop="$router.push('/supplier')">{{i18n('36')}}</div>
				<div @click="centerTz(8,'/QandA')">{{i18n('24')}}</div>
				<div @click.stop="$router.push('/policy')">{{i18n('68')}}</div>
			</div>
			<div class="bot">
				Confidential and Proprietary. Copyright (c) by Yeah Fresh. All Rights Reserved. <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank">粤ICP备2021090817号</a>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: "footers",
		data() {
			return {
				
			}
		},
		methods: {
			centerTz(type, url) {
				this.$store.commit("user/setUserCenterType", type)
				this.$router.push(url)
			},
		},
		mounted() {
	
		},
	};
</script>

<style scoped="scoped">
	.tab{
		margin-bottom: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
	}
	.tab div{
		padding: 0 20px;
		cursor: pointer;
	}
	#footers{
		width: 1300px;
		margin: 0 auto;
		height: 140px;
		background: #fff;
		display: flex;
		align-items: center;
		justify-content: center;
		font-family: PingFangSC-Regular;
		font-size: 15px;
		color: #4E5969;
	}
	#footers a{
		color: #4E5969;
	}
</style>
